/**
 * Footer — the publish modal's Cancel / Publish actions.
 *
 * Extracted from PublishConfirmModal so each file declares one component
 * (`react/no-multi-comp`); behaviour is unchanged.
 */
import { disabledStyle } from './publishModalHelpers';

export function Footer({
  canConfirm,
  publishing,
  onConfirm,
  onClose,
}: {
  canConfirm: boolean;
  publishing: boolean;
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
}) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: 10,
        paddingTop: 2,
      }}
    >
      <button
        type="button"
        className="nb-btn nb-btn-ghost"
        onClick={onClose}
        disabled={publishing}
        style={disabledStyle(publishing)}
      >
        Cancel
      </button>
      <button
        type="button"
        className="nb-btn nb-btn-primary"
        onClick={() => void onConfirm()}
        disabled={!canConfirm}
        // Make the disabled state visually obvious — `nb-btn` has no `:disabled`
        // rule, so without this the button still looks clickable while blockers
        // remain (BON-215 review feedback).
        style={disabledStyle(!canConfirm)}
        title={!canConfirm && !publishing ? 'Resolve the issues above to publish' : undefined}
      >
        {publishing ? 'Publishing…' : 'Publish workshop'}
      </button>
    </div>
  );
}
